import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router";
import styled from "styled-components";

const NavList = styled.ul`
  margin: ${({ theme }) => theme.space[2]};
  display: flex;
  background-color: ${({ theme }) => theme.colors.white};
  gap: ${({ theme }) => theme.space[1]};
  margin: ${({ theme }) => theme.space[2]};
  padding: ${({ theme }) => theme.space[1]};
  border-radius: 8px;
  list-style-type: none;
  padding-inline-start: 0;
  padding: 2px;

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    margin: ${({ theme }) => theme.space[2]} 0;
  }
`;

const NavItem = styled.li`
  flex: 1;
`;

const StyledNavLink = styled(NavLink)`
  display: block;
  padding: ${({ theme }) => `0.8rem ${theme.space[2]} ${theme.space[1]}`};
  border-radius: ${({ theme }) => theme.radii[4]};
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.primary};
  font-family: ${({ theme }) => theme.fonts.bold};
  text-decoration: none;
  text-align: center;

  &.active {
    background-color: ${({ theme }) => theme.colors.blue};
    color: ${({ theme }) => theme.colors.white};
    border-radius: 8px;
  }
`;

interface IProps {
  defaultEntry?: number;
  leagueId: number;
  eventId: number;
}

const H2HNav: React.FC<IProps> = ({ eventId, leagueId, defaultEntry }) => {
  const defaultEntryParam = defaultEntry ? `default_entry=${defaultEntry}` : "";
  const { t } = useTranslation();
  const links = [
    {
      href: `/leagues/${leagueId}/matches/h`,
      qs: `?event=${eventId}` + (defaultEntryParam && `&${defaultEntryParam}`),
      text: t("h2hNav.matches", "Matches"),
    },
    {
      href: `/leagues/${leagueId}/standings/h`,
      qs: defaultEntryParam && `?${defaultEntryParam}`,
      text: t("h2hNav.standings", "Standings"),
    },
  ];
  return (
    <nav>
      <NavList>
        {links.map((l) => (
          <NavItem key={l.href}>
            <StyledNavLink to={`${l.href}${l.qs}`} end>
              {l.text}
            </StyledNavLink>
          </NavItem>
        ))}
      </NavList>
    </nav>
  );
};

export default H2HNav;
